/* eslint-disable */
import React from "react";
import { Modal, Text, Group, Button } from "@mantine/core";

const DeleteConfirmationModal = ({
  opened,
  onClose,
  onConfirm,
  isLoading,
}: any) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      title="Delete Confirmation"
    >
      <Text size="sm" mb="md">
        Are you sure you want to delete this item?
      </Text>

      <Group position="right">
        <Button variant="default" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="red" onClick={onConfirm} loading={isLoading}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
};

export default DeleteConfirmationModal;
